import { FC, useState } from 'react'
import { FFModal } from '~/shared/ui'
import { Box, Button, FormControlLabel, Radio, RadioGroup, Typography } from '@mui/material'
import { visitRatingsVisitDuration, visitRatingsVisitDurationRatingList } from '@fireflyhealth/api'
import { useQuery } from '~/shared/hooks/query'
import { useMutation } from '~/shared/hooks/useMutation'

interface AppointmentFeedbackProps {
  appointment: { id: number }
  onClose: () => void
}

const AppointmentVisitFeedback: FC<AppointmentFeedbackProps> = props => {
  const [radioButtonValue, setRadioButtonValue] = useState<string | null>(null)

  const { data: visitRatings } = useQuery(
    visitRatingsVisitDurationRatingList.listQueryKey(),
    async () => {
      const response = await visitRatingsVisitDurationRatingList.list()
      return response.data
    },
    {},
    { error: 'Failed to fetch visit duration rating' },
  )

  const { run: submit, loading: saving } = useMutation(
    async () => {
      await visitRatingsVisitDuration.create({
        data: {
          appointment: props.appointment?.id,
          visit_duration: Number(radioButtonValue),
        },
      })
      props.onClose()
    },
    { error: 'Failed to save your feedback' },
  )

  return (
    <FFModal
      open
      header={
        <Box sx={{ p: 1 }}>
          <Typography variant="h6" align="center">
            How was the appointment duration?
          </Typography>
        </Box>
      }
      footer={
        <Box sx={{ my: 1, mx: 2, display: 'flex', justifyContent: 'flex-end' }}>
          <Button
            disabled={radioButtonValue === null || saving}
            variant="contained"
            color="primary"
            onClick={submit}
          >
            <Typography>Done</Typography>
          </Button>
        </Box>
      }
    >
      <Box sx={{ m: 2 }}>
        <RadioGroup
          sx={{ width: '80%' }}
          value={radioButtonValue}
          onChange={e => {
            setRadioButtonValue(e.target.value)
          }}
        >
          {visitRatings &&
            visitRatings.length > 0 &&
            visitRatings.map(rating => (
              <FormControlLabel
                key={rating.id}
                value={rating.id}
                control={<Radio />}
                label={<Typography>{rating.label}</Typography>}
              />
            ))}
        </RadioGroup>
      </Box>
    </FFModal>
  )
}

export default AppointmentVisitFeedback
